import React from 'react';
import useJumboApp from "@jumbo/hooks/useJumboApp";
import {config} from "../../../app/config/main";
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { useLocation, useNavigate } from 'react-router-dom';

const Page = ({component, layout, ...restProps}) => {
    const navigate = useNavigate()
    const {activeLayout, setActiveLayout} = useJumboApp();
    const {menuObject,setAuthOptions,authOptions} = useJumboAuth()
    React.useEffect(() => {
        if (layout !== activeLayout) {
            setActiveLayout(layout);
        }
    }, [layout]);
    // console.log();
    const location =useLocation()
    const PageComponent = component;


    React.useEffect(() => {
        const MenuRights = menuObject?.Gaurd?.filter(s=>s.uri==PageComponent.Modulename)
        if(Array.isArray(MenuRights) &&MenuRights <1 && PageComponent.Modulename){
            // console.log('norights',PageComponent.Modulename);
            navigate('/dashboard')
            // Navigate
        } else{           
            Array.isArray(MenuRights) && setAuthOptions({ type: "page-rights", payload: MenuRights[0] })
            // console.log(MenuRights,PageComponent.Modulename);
        }
    }, [menuObject,location]);

    return (
        <PageComponent {...restProps} />
    );
};

Page.defaultProps = {
    layout: config.defaultLayout
};

export default Page;